import './App.css';

import {BrowserRouter as Router, Routes, Route, Link} from "react-router-dom"
import Home from "./Pages/Home";
import About from "./Pages/About";
import Shop from "./Pages/Shop";
import Cart from "./Pages/cart";
import NotFound from "./Pages/NotFound";
import Task from "./Pages/Task";
import Contact from "./Pages/Contact";
import FormReducer from "./Pages/FormReducer";

import {useSelector} from "react-redux";
// import {addToCart, removeFromCart, clearCart} from "./redux/cartSlice";

import {ThemeProvider} from "./Context/ThemeContext";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import Counter from "./Pages/Counter";

// const queryClient = new QueryClient();

function App() {

    const cartitem = useSelector((state) => state.cart.cart); // دسترسی به state
    // const dispatch = useDispatch(); // برای ارسال action

    const totalItems = cartitem.reduce((sum, item) => sum + item.quantity, 0);
    // console.log("App:",totalItems)

    const client = new QueryClient({
        defaultOptions: {
            queries:  { refetchOnWindowFocus: false},
            mutations: {}
        }
    })
    return (
        <QueryClientProvider client={client}>
            <ThemeProvider>
                <div className="App pt-5">
                    <Router>

                        <nav className='navbar navbar-expand-lg   bg-dark fixed-top'>
                            <Link to="/" className='nav-item mx-2 text-white'>خانه</Link>
                            <Link to="/about" className='nav-item mx-2 text-white'>درباره ما</Link>
                            <Link to="/contact" className='nav-item mx-2 text-white'>تماس با ما</Link>
                            <Link to="/Shop" className='nav-item mx-2 text-white'>فروشگاه</Link>
                            <Link to="/task" className='nav-item mx-2 text-white'>وضایف</Link>
                            <Link to="/cart" className='nav-item mx-2 text-white'>سبد خرید</Link>
                            {totalItems > 0 && <span className='text-danger ms-2'>({totalItems})</span>}
                            <Link to="/counter" className='nav-item mx-2 text-white'>کاستوم Hook</Link>
                            <Link to="/Reducer" className='nav-item mx-2 text-white'> Reducer  </Link>
                        </nav>


                        <Routes>
                            <Route path={"/"} element={<Home/>}>Home</Route>
                            <Route path={"/About"} element={<About/>}>About</Route>
                            <Route path={"/contact"} element={<Contact/>}>Contact</Route>
                            <Route path={"/Shop"} element={<Shop/>}>Shop</Route>
                            <Route path={"/cart"} element={<Cart/>}>Cart</Route>
                            <Route path={"/task"} element={<Task/>}>task</Route>
                            <Route path={"/counter"} element={<Counter/>}>task</Route>
                            <Route path={"/Reducer"} element={<FormReducer/>}>Reducer</Route>
                            <Route path="*" element={<NotFound/>}/>
                        </Routes>


                    </Router>
                </div>
            </ThemeProvider>
        </QueryClientProvider>
    );
}

export default App;
